export const UnauthorisedResponse = {
  statusCode: 401,
  success: false,
  error: {
    message: 'Unauthorized',
    code: '401'
  },
  validationErrors: {},
  result: null
};
